import React from "react";
import aboutImg from "../images/doctor.png";
import chart from "../images/warranty.png";
import "../style/About.css";
import "../style/Common.css";
import { useMediaQuery } from "react-responsive";

const About = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <section className="about" id="about">
      <div className="AboutContainer">
        <img
          src={aboutImg}
          alt="About Us"
          style={{
            width: isMobile ? "100%" : "30%",
            height: isMobile ? "100%" : "30%",
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <h4 className="section-title">Quality Assurance</h4>
          <h1 className="main-title">A Lifetime of Smile Confidence!</h1>
          <div className="features">
            <div className="feature">
              <img src={chart} alt="" width={60} height={60} />
              <h3>With You Every Step</h3>
              <p>
                From consultation to results, our expert-guided treatment
                ensures a beautifully aligned smile. We’re committed to
                long-lasting care, so you can smile with confidence for years to
                come.
              </p>
            </div>
            {/* <div className="feature">
              <img src={healthcare} alt="" />
              <h3>Highly Professional Staff</h3>
              <p>
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy
              </p>
            </div> */}
          </div>
          <button
            className="link-btn"
            onClick={() => {
              window.location.href = "/#contact";
            }}
          >
            Start Today
          </button>
        </div>
        {/* <span>about us</span>
          <h3>Genuine Family Healthcare</h3>
          <p>DentalClinic helps you achieve the quintessentially oriented smile you have always craved. Our product gets the job done without making you go through any hassle or discomfort.</p>
          <a href="#contact" className="link-btn">reserve appointment</a> */}
      </div>
    </section>
  );
};

export default About;
